<div class="form-check form-switch form-switch-lg">
    <input class="form-check-input" type="checkbox" role="switch" id="checkbox" [checked]="checked" (change)="changeCheckbox($event)">
</div>